var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNonfilledYellowStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 100,
    viewBox: "0 0 104 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6429 31.4201L52.0003 6.79728L63.3577 31.4201L67.9907 29.2831L63.3577 31.4201C64.6836 34.2946 67.4077 36.2738 70.5512 36.6465L97.4786 39.8392L77.5705 58.2496C75.2464 60.3988 74.2058 63.6012 74.8228 66.7061L80.1074 93.3021L56.4461 80.0575C53.6839 78.5113 50.3167 78.5113 47.5544 80.0575L23.8932 93.3021L29.1777 66.7061C29.7947 63.6012 28.7542 60.3988 26.4301 58.2496L6.52199 39.8392L33.4493 36.6465C36.5929 36.2738 39.317 34.2946 40.6429 31.4201Z",
    stroke: "#FEE502",
    strokeWidth: 10.2042
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonfilledYellowStar);
export default __webpack_public_path__ + "static/media/nonfilledYellowStar.ad805e63c9c6294e715bd9df6f2c724e.svg";
export { ForwardRef as ReactComponent };